import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import DeviceManagement from '../views/DeviceManagement.vue'
import DynamicDeviceManagement from '../views/DynamicDeviceManagement.vue'
import UserManagement from '../views/UserManagement.vue'
import FieldConfig from '../views/FieldConfig.vue'
import BorrowRequestManagement from '../views/BorrowRequestManagement.vue'
import AccessoryManagement from '../views/AccessoryManagement.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'DashboardDefault',
        redirect: '/dashboard/devices'
      },
      {
        path: 'devices',
        name: 'DeviceManagement',
        component: DynamicDeviceManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'devices/legacy',
        name: 'LegacyDeviceManagement',
        component: DeviceManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'users',
        name: 'UserManagement',
        component: UserManagement,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'field-config',
        name: 'FieldConfig',
        component: FieldConfig,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'borrow-requests',
        name: 'BorrowRequestManagement',
        component: BorrowRequestManagement,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'accessories',
        name: 'AccessoryManagement',
        component: AccessoryManagement,
        meta: { requiresAuth: true, requiresAdmin: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next('/login')
    } else if (to.matched.some(record => record.meta.requiresAdmin)) {
      if (user.role === 'ADMIN' || user.role === 'admin') {
        next()
      } else {
        next('/dashboard/devices')
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router